import { DndContext } from '@dnd-kit/core'
import { SortableContext, arrayMove, useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { Tag } from 'antd'
import StyledLoader from 'components/Elements/StyledLoader'
import SectionTitle from 'components/SectionTitle'
import { QuestionItemContainer } from 'sections/Dashboard/features/Story/style'
import { useEffect, useState } from 'react'
import { Button } from 'react-bootstrap'
import { useParams } from 'react-router-dom'
import {
  useBookQuery,
  useBookQuestionsQuery,
  useBookRoleQuery,
  usePromptOrderMutation,
} from 'store/queries'
import PromptOrderContainer from './style'

const SortablePrompt = ({ prompt }) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: prompt.id })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  }
  return (
    <QuestionItemContainer
      ref={setNodeRef}
      style={style}
      className="b-line prompt-item"
      {...attributes}
      {...listeners}
    >
      <div className="desktop">
        <h6 className={`question-content question-gray`}>
          {prompt.dsply_text}
        </h6>
        {typeof prompt.tags === 'string' &&
          prompt.tags.split(',').map((_tag, _i) => {
            return (
              <Tag
                key={_i}
                color={`${_tag.split(':')[1] || '#52725D'}`}
                className="ml-2"
              >
                {_tag.split(':')[0]}
              </Tag>
            )
          })}
      </div>
      <div className="mobile py-2">
        <div className="bottom">
          <h6 className="question-content">{prompt.dsply_text}</h6>
        </div>
      </div>
    </QuestionItemContainer>
  )
}

function PromptOrder() {
  const [orderedPrompts, setOrderedPrompts] = useState([])
  const { bookId } = useParams()

  const { data: book } = useBookQuery(bookId)
  const { data: role } = useBookRoleQuery(bookId)
  const { data: questions } = useBookQuestionsQuery(bookId)
  const disabled = book.is_published

  const orderMutation = usePromptOrderMutation(bookId)

  const inConfirmState =
    role?.name === 'Purchaser' && book?.is_publish_started === true

  useEffect(() => {
    setOrderedPrompts(
      structuredClone(questions)
        .filter((q) => !q.is_sent)
        .sort((a, b) => a.sort - b.sort),
    )
  }, [questions])

  const handleDragEnd = (e) => {
    const { active, over } = e

    if (active.id !== over.id) {
      setOrderedPrompts((oldPrompts) => {
        const oldIndex = oldPrompts.findIndex((p) => p.id === active.id)
        const newIndex = oldPrompts.findIndex((p) => p.id === over.id)
        const newPrompts = arrayMove(oldPrompts, oldIndex, newIndex)

        newPrompts.forEach((p, i) => {
          p.sort = i
        })

        return newPrompts
      })
    }
  }

  if (!book.id) return <StyledLoader />

  return (
    <PromptOrderContainer className="section-container">
      <SectionTitle className="mt1rem">Story Prompt Order</SectionTitle>

      <></>
      <div className="prompts-list">
        <DndContext onDragEnd={handleDragEnd}>
          <SortableContext
            disabled={disabled}
            items={orderedPrompts.map((p) => p.id)}
          >
            {orderedPrompts.map((p) => (
              <SortablePrompt key={p.id} prompt={p} />
            ))}
          </SortableContext>
        </DndContext>
      </div>

      <div className="modal-footer">
        <div className="btns-wrapper actions">
          <Button
            disabled={disabled}
            className="btn-white btn-dash cancel"
            onClick={() => {
              // Reset
              setOrderedPrompts(
                structuredClone(questions).sort((a, b) => a.sort - b.sort),
              )
            }}
          >
            Cancel Changes
          </Button>
          <Button
            disabled={disabled}
            className="btn-blue btn-dash"
            onClick={() =>
              orderMutation.mutate({
                prompts: orderedPrompts,
                isConfirmed: inConfirmState ? true : book.story_order_confirmed,
              })
            }
          >
            Save Order
          </Button>
        </div>
      </div>
    </PromptOrderContainer>
  )
}

export default PromptOrder
